// The administrator password, in the browser, on purpose.
//
// Kevin, 2026-09-02: "the password should be 110333 and when i type it in i should see
// success or fail not when i save."
//
// The second half is why this constant exists. Answering at the Unlock button means either
// a round trip to the server (an endpoint that has to be deployed and reachable -- it was
// neither on 2026-09-02, and its 404 blocked the whole feature) or the value here. He chose
// the trade explicitly and more than once: "the password is safe to store in the code it
// doesnt mean anything and if anyone has it then it doesnt impact much."
//
// WHAT THIS IS NOT. It is not the gate. Anyone can read a static bundle, so a code compared
// in React is a label on a door. The lock is enforced in api/create-assembly, which
// re-validates the code on the request that WRITES, at every one of its gates, and fails
// closed -- a browser that has convinced itself it is unlocked still cannot edit a locked
// item. This only decides what the operator is told, immediately, before they spend time
// editing a configuration they would not be allowed to save.
//
// KEEP IN STEP with DEFAULT_CODE in api/shared/admin-override.js. `npm run check:admincode`
// fails the build if they drift -- two copies of a password that disagree would refuse a
// correct entry at save time with no way to tell why, which is the exact afternoon this
// whole change came out of.
export const ADMIN_CODE = "110333";

/** Is this what the administrator password is? Trimmed, because a pasted value carries
 *  whitespace and the server trims too -- the two must agree on what "correct" means. */
export function isAdminCode(typed: string): boolean {
  return String(typed ?? "").trim() === ADMIN_CODE;
}
